'use client'
import { usePathname } from '@/i18n/navigation'
import { NewsArticle } from '@/lib/news'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import { UsefulInformationTabs } from './useful-information-tabs'

export function Wrapper({ articles }: { articles: NewsArticle[] }) {
  const [categoryId, setCategoryId] = useState<string>('financial-mediator')

  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {}, [pathname, searchParams])

  const handleCategoryChange = (categoryId: string) => {
    if (categoryId) setCategoryId(categoryId)
  }

  return (
    <div className="mx-auto max-w-[1020px] space-y-12 pt-8 md:pt-24">
      <UsefulInformationTabs
        articles={articles}
        onSelectTab={handleCategoryChange}
        selectedTab={categoryId}
      />
    </div>
  )
}
